import type { SceneModule } from '../_shared/types'
import QuoteCard from './QuoteCard'
import { QuoteCardEditor } from './Editor'
import { render } from './svgRender'
import { QuoteCardComposition } from './Composition'

export const module: SceneModule = {
  id: 'quote-card',
  Component: QuoteCard,
  Composition: QuoteCardComposition,
  Editor: QuoteCardEditor,
  svgRender: render,
}
